module.exports = __webpack_public_path__ + "assets/img/two.ddf19cbc.jpg";